import { useEffect, useRef, useState } from 'react';

interface StickyToolbarWrapperProps {
  children: React.ReactNode;
  stickyTop?: number;
  type?: string;
  isHandleScroll?: boolean;
  className?: string;
}

const StickyToolbarWrapper = ({
  children,
  stickyTop = 120,
  isHandleScroll = true,
  className,
  type,
}: StickyToolbarWrapperProps) => {
  const [isSticky, setIsSticky] = useState(false);
  const toolbarRef = useRef<HTMLDivElement>(null);
  const initialPositionRef = useRef<number | null>(null);

  useEffect(() => {
    if (isHandleScroll) {
      const handleScroll = () => {
        if (toolbarRef.current) {
          const offsetTop = toolbarRef.current.getBoundingClientRect().top;

          if (initialPositionRef.current === null) {
            initialPositionRef.current = offsetTop;
            return;
          }

          const hasScrolledPastInitialPosition = window.scrollY > 0 && offsetTop <= stickyTop;
          setIsSticky(hasScrolledPastInitialPosition);
        }
      };

      handleScroll();
      window.addEventListener('scroll', handleScroll, { passive: true });

      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [stickyTop]);

  return (
    <div
      ref={toolbarRef}
      style={{ top: `${stickyTop}px` }}
      className={`
    sticky z-10 transition-all overflow-hidden duration-300
    ${type !== 'nomargin' ? 'rounded-lg' : ''}
    ${isSticky && isHandleScroll ? (type === 'nomargin' ? 'shadow' : '-mx-6 shadow rounded-none') : ''}
    ${className}
  `}
    >
      {children}
    </div>
  );
};

export default StickyToolbarWrapper;
